import { render } from "./RegisterCheckEmail.vue?vue&type=template&id=5782118a&scoped=true"
import script from "./RegisterCheckEmail.vue?vue&type=script&lang=js"
export * from "./RegisterCheckEmail.vue?vue&type=script&lang=js"

import "./RegisterCheckEmail.vue?vue&type=style&index=0&id=5782118a&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5782118a"]])

export default __exports__